import { Bando } from "./bando.model";

export class Impresa {
    id: number;
    ragioneSociale: string;
	bandi: Bando[];
  }
  